<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="row">
              <div class="mobileDeviceViewing col-md-5">
                <div class="form-group">
                  <p style="font-size:35px">{{workflow.name}}</p>
                  <p>{{workflow.description}}</p>
                  <p>{{workflow.active == true ? 'Active' : 'Inactive'}}</p>
                  <p v-show="!workflow.ranger">{{workflow.critical == false ? 'Non Critical' : 'Critical'}}</p>
                  <p v-show="!workflow.ranger">{{workflow.endtimebased == false ? 'Start Time Based' : 'End Time Based'}}</p>
                  <p v-show="!workflow.ranger">Schedule: {{workflow.schedule}} Minutes</p>
                  <p v-show="!workflow.ranger">Warn Before: {{workflow.warnBefore}} Minutes</p>
                  <p>Last Completed: {{filteredData.lastcompleted}}</p>
                  <p v-show="!workflow.ranger">Next Due: {{filteredData.nextdue}}</p>
                </div>
              </div>
              <div class="col-md-5 offset-md-1" v-show="!workflow.ranger">
                <h5>Tasks</h5>

                <div v-if="org['curOrg']['role'] == 99">
                  <button v-on:click="tasksJsonView = true" type="button" v-if="!tasksJsonView" class="btn btn-default">JSON View</button>
                  <button v-on:click="tasksJsonView = false" type="button" v-else class="btn btn-default">Normal View</button>
                </div>
                <br>

                <br>

                <p>{{tasks.length - 1}} Tasks</p>

                <div v-if="!tasksJsonView">
                  <div class="list-group" v-for="task in tasks">
                    <div class = "list-group-item" v-for="element in task">
                      <div v-if="element.name == 'Location Tag'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small>Speak Text: {{element.speak}}</small>
                        <br>
                        <small class="">Tag Name: {{element.description}}</small>
                      </div>
                      <div v-else-if="element.name == 'Input'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small>Type: {{inputTypes.find(function(inputType){return inputType['.key'] == element.type})['name']}}</small>
                        <br>
                        <small class="">Name: {{element.description}}</small>
                      </div>
                      <div v-else-if="element.name == 'Temperature'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small class="">Name: {{element.description}}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <pre>{{ tasks | pretty }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'workflowdetail',
  data () {
    return {
      org: store.state.usermain,
      workflow: {
        name: '',
        active: true,
        critical: true,
        endtimebased: true,
        description: '',
        schedule: '',
        warnBefore: '',
      },
      tasks:[],
      devices: [],
      searchQuery: '',
      gridColumns: ["Devices"],
      allDevices: [],
      tasksJsonView: false,

      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}],
    }
  },
  created:function(){
    this.fetchAll()
  },
  methods: {
    fetchAll:function(){
      this.fetchWorkflow()
    },
    fetchWorkflow: function(){
      this.$bindAsObject('workflow', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows/' + this.$route.params.id), null, function(){
        this.tasks = this.workflow.tasks;
      });
    },
  },
  computed: {
    filteredData:function(){
      var data = this.workflow

      var pubDate = new Date(data['nextdue']*1000);
      var weekday=new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
      var monthname=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
      var hours = pubDate.getHours();
      var minutes = pubDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var time = hours + ':' + minutes + ' ' + ampm;
      var formattedDate = weekday[pubDate.getDay()] + ' ' 
                + monthname[pubDate.getMonth()] + ' ' 
                + pubDate.getDate() + ', ' 
                + pubDate.getFullYear() + ' at ' 
                + time

      data['nextdue'] = formattedDate

      if (data['lastcompleted'] != ''){
        var pubDate = new Date(data['lastcompleted']*1000);
        var weekday=new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
        var monthname=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
        var hours = pubDate.getHours();
        var minutes = pubDate.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var time = hours + ':' + minutes + ' ' + ampm;
        var formattedDate = weekday[pubDate.getDay()] + ' ' 
                  + monthname[pubDate.getMonth()] + ' ' 
                  + pubDate.getDate() + ', ' 
                  + pubDate.getFullYear() + ' at ' 
                  + time

        data['lastcompleted'] = formattedDate
      }else{
        data['lastcompleted'] = "Never"
      }

      return data
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ArchivedWorkflowDetail.vue?99b3b9bc